import { render, staticRenderFns } from "./AuthSecurity.vue?vue&type=template&id=3f704a1b"
import script from "./AuthSecurity.vue?vue&type=script&lang=ts"
export * from "./AuthSecurity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports